export const SUPPORTED_FILE_TYPES = ['audio/mpeg', 'audio/x-m4a', 'audio/wav'];

export const SUPPORTED_SMS_FILE_SIZE = 5000000;
export const SUPPORTED_SMS_FILE_TYPES = [
  'audio/basic',
  'audio/L24',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/vorbis',
  'audio/vnd.rn-realaudio',
  'audio/vnd.wave',
  'audio/3gpp',
  'audio/3gpp2',
  'audio/ac3',
  'audio/vnd.wave',
  'audio/webm',
  'audio/amr-nb',
  'audio/amr',
  'video/mpeg',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
  'video/3gpp-tt',
  'video/H261',
  'video/H263',
  'video/H263-1998',
  'video/H263-2000',
  'video/H264',
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/bmp',
  'text/vcard',
  'text/csv',
  'text/rtf',
  'text/richtext',
  'text/calendar',
  'text/directory',
  'application/pdf',
];

export const FILE_SIZE_LIMIT = 15 * 1024 * 1024; // 15MB

export interface FileDto {
  id?: string;
  name: string;
  creatorUserId: string;
  subjectUserId: string;
  s3Bucket?: string;
  s3Key?: string;
  s3ETag?: string;
  contentLength?: number;
  mimeType: string;
  source: string;
  category: FileCategoryDto;
  saved?: boolean;
  contentDuration: number;
  originalFileName: string;
  createdAt?: number;
  updatedAt?: number;
}

export interface FileMeta {
  contentDuration: number;
  originalFileName: string;
  name: string;
  contentLength: number;
  mimeType: string;
}
export interface FileCategoryDto {
  id: number;
  key: string;
  name: string;
  s3Bucket: string;
  s3KeyPrefix: string;
}

export interface FileCreateRequest {
  fileName: string;
  mimeType: string;
  size: number;
}

export interface FileUploadLinkResponse {
  file: FileDto;
  url: string;
}

export interface TemporaryLinkResponse {
  temporaryUrl: string;
  expires: number;
  file: FileDto;
}
